import {
  publicHttpClient,
  apiRoutes,
  type DefaultQueryError,
  type User,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export interface VerifyLoginRequest {
  mobile: string;
  client_type: string;
  device_type: string;
  imei: string;
  code: string;
  login_method: string;
  login_type?: string;
  push?: string;
  fcm?: boolean;
}

export interface VerifyLoginResponse {
  token: string;
  refresh_token: string;
  firebase_token: string;
  user: User;
}

export enum VerifyLoginErrorCode {
  WrongPasscodeExceededLimitCode = 'WRONG_PASSCODE_EXCEEDED_LIMIT',
}

export type VerifyLoginError = DefaultQueryError<VerifyLoginErrorCode>;

export const verifyLoginFn = async (params: VerifyLoginRequest) => {
  const response = await publicHttpClient.post(apiRoutes.auth.verifyV4, params);
  return response.data;
};

export const useVerifyLogin = (
  opts?: UseMutationOptions<
    VerifyLoginResponse,
    VerifyLoginError,
    VerifyLoginRequest
  >
) =>
  useMutation({
    mutationKey: [apiRoutes.auth.verifyV4],
    mutationFn: verifyLoginFn,
    ...opts,
  });
